import http from '../http'
import qs from 'qs'

export default {
    /**
     * Consulta los modulos del usuario
     * @param {int} usuario
     * @returns {Promise}
     */
    all(usuario, query = {}) {
        return http.get(`usuarios/${usuario}/actividades?${qs.stringify(query)}`);
    },
}